
const PATH_NAMES={elena:"The Everyday Comfort",sofia:"The Calm Comfort",daniela:"The Even-Tone Luminosity",bianca:"The Balanced Clarity",mara:"The Overnight Resilience",petra:"The Firmness & Bounce",rocco:"The Fresh Shave Comfort"};

/* Canonical real answer combinations, one per path.
   Used by the mockup hashes and the QA tour; every one of these
   runs through composeRitual. No previews, no forcing. */
const CANONICAL={
  elena:[[0],[0],[0],[2],[1],[2],[0]],
  sofia:[[4],[0],[4],[2],[0],[2],[4]],
  daniela:[[1,2],[1],[4],[2],[1],[0],[3]],
  bianca:[[3],[3],[0],[2],[1],[2],[0]],
  mara:[[5],[4],[2],[2],[1],[2],[4]],
  petra:[[6],[5],[3],[2],[1],[0],[2]],
  rocco:[[0],[0],[0],[0],[0],[1],[0]]
};

/* ----- Base path selection: Final Logic v1.2 priority order, unchanged.
   Question VII may only break the final tie; it never overrides a rule. ----- */
function basePath(a,D){
  const q1=a[0]||[],q2=a[1]||[],q6=a[5]||[],q7=a[6]||[];
  if(q6.includes(1)){D("Question VI names frequent shaving, so the shave gate leads. This is the only route to the Men’s gel-cream, and the exfoliating serum never joins a freshly shaved day.");return "rocco";}
  if(q1.includes(5)){
    if(q2.includes(3)&&q1.includes(3)){D("Worn down and congested with Balance as the devotion: the correction path leads, held to the balance reset.");return "bianca";}
    D("Worn down is the strongest signal of all, so resilience leads.");return "mara";
  }
  if(q2.includes(4)){D("Resilience is the devotion, so the overnight resilience path leads.");return "mara";}
  if(q1.includes(3)&&q2.includes(3)){D("Congested skin with Balance as the devotion: the correction path leads.");return "bianca";}
  if(q2.includes(5)){D("The look of firmness is the devotion: the peptide path leads.");return "petra";}
  if(q1.includes(4)){D("Skin that is easily overwhelmed earns calm first.");return "sofia";}
  if(q2.includes(1)||q1.includes(1)||q1.includes(2)){D("Dull or uneven tone with luminosity in view: the even-tone path leads.");return "daniela";}
  if(q7.includes(3)){D("No rule above applied, and the final feel you asked for is luminous. Question VII broke the tie toward the even-tone path.");return "daniela";}
  D("Comfort is the quiet default of the house: the Everyday Comfort path.");return "elena";
}

/* ----- Seal selection: Question III first, house rules always win ----- */
const DAY_SEAL_DEFAULT={elena:"illume",sofia:"luscious",daniela:"illume",mara:"luscious",petra:"luscious"};
function chooseDaySeal(path,tex,q7,D){
  if(path==="bianca"){if(tex===2||tex===3)D("You asked for cushion, but congestion asks for a light close, so the house held the glass-skin gel in both sittings. The house explains, it does not ignore.");return "illume";}
  if(path==="rocco"){if(tex!==undefined&&tex!==4)D("The shave path keeps its cool gel-cream seal whatever the texture preference; calm and simple wins here.");return "mens";}
  const def=DAY_SEAL_DEFAULT[path];
  if(tex===0){if(def!=="illume")D("Weightless, as asked: the day seal moves to the glass-skin gel.");else D("Weightless, as asked: the glass-skin gel keeps the seal.");return "illume";}
  if(tex===2){if(def!=="luscious")D("Cushiony, as asked: the water cream takes the day seal.");else D("Cushiony, as asked: the water cream keeps the day seal.");return "luscious";}
  if(tex===3){D("Rich, as asked: cushion by day, cocoon by night.");return "luscious";}
  if(tex===1){
    if(q7===1){D("Silky textures lead your layers, and you asked to finish soft, so the day closes in cushion.");return "luscious";}
    if(q7===2){D("Silky textures lead your layers, and you asked to finish cocooned: cushion by day, the cocoon cream by night.");return "luscious";}
    if(q7===0){D("Silky textures lead your layers, and you asked to finish fresh, so the day closes in glass.");return "illume";}
    D("Silky textures noted: the fluid layers lead and the seal stays light.");return def;
  }
  if(q7===0&&def!=="illume"){D("You left texture to the house and asked to finish fresh, so the day closes in glass.");return "illume";}
  if(q7===1&&def!=="luscious"){D("You left texture to the house and asked to finish soft, so the day closes in cushion.");return "luscious";}
  if(q7===2&&def!=="luscious"){D("You left texture to the house and asked to finish cocooned, so the day closes in cushion.");return "luscious";}
  D("You left texture to the house, so the seal follows the path’s own logic.");return def;
}
function chooseEveSeal(path,tex,q7,daySeal,D){
  if(path==="petra")return "moonlit";
  if(path==="bianca")return "illume";
  if(path==="rocco")return "mens";
  if(tex===3){D("The evening ends in the cocoon cream, rich as you asked.");return "moonlit";}
  if(q7===2&&tex!==0){D("To finish cocooned, the evening closes in the cocoon cream.");return "moonlit";}
  if(q7===2&&tex===0){D("You asked to finish cocooned, but weightless is the texture you love, and a stated texture always leads. The seal stays true to what you asked to wear.");}
  return daySeal;
}

/* Seal card copy: product truth first, then the reason it was chosen */
function sealWhy(k,path,tex,slotTime){
  const base={
    illume:"Snow mushroom and kakadu plum in a weightless gel: fresh, glassy hydration that quenches deeply and leaves nothing behind to feel.",
    luscious:"A deep cushion of hydration, the most moisture-sealing cream on our bench.",
    moonlit:"Squalane, shea butter, and Ceramide NP in a plush night cream: the richer close for evenings when skin wants to feel cocooned.",
    mens:"A cool, fast-absorbing gel-cream made for thicker, frequently shaved skin. One seal, and the ritual is done."
  }[k];
  let note="";
  if(k==="illume"&&path==="bianca")note=" Congested skin asks for a light close, so the house held the glass gel here.";
  else if(k==="illume"&&tex===0)note=" Weightless is its native language, and yours asked for exactly that.";
  else if(k==="luscious"&&tex===2)note=" Cushiony, as you asked: deeply hydrating, never greasy.";
  else if(k==="luscious"&&tex===3&&slotTime==="am")note=" By day, the cushion; the plush cocoon belongs to the evening.";
  else if(k==="moonlit"&&tex===3)note=" Rich, as you asked: the night ends cocooned.";
  return base+note;
}

